<div class="container">
    <div class="row">
  
      <div class="col-md-12">
        <div class="main-card mb-3 card">
          <div class="card-header font-weight-B fs-1r">Add Driver</div>
          <div class="card-body">
  
      <div class="row">
        <div class="col-md-2"></div>
          <div class="col-md-4">
            <label for="">First Name : </label>
            <input type="text"  class="form-control" placeholder="First name" [(ngModel)]="fName">
          </div>
          <div class="col-md-4">
            <label for="">Last Name : </label>
            <input type="text"  maxlength="10" class="form-control" placeholder="Last name" [(ngModel)]="lName">
          </div>
          <div class="col-md-2"></div>
        </div>

        <div class="row">
            <div class="col-md-2"></div>
              <div class="col-md-4">
                <label for="">Email ID : </label>
                <input type="email"  class="form-control" placeholder="Email ID" [(ngModel)]="emailId">
              </div>
              <div class="col-md-4">
                <label for="">Mobile No. : </label>
                <input type="text"  maxlength="10" class="form-control" placeholder="Mobile no." [(ngModel)]="mobileNumber">
              </div>
              <div class="col-md-2"></div>
            </div>
            
        <div class="row">
          <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for="">City : </label>
              <input type="text" (onAddressChange)="getCityData($event)"  ngx-google-places-autocomplete   placeholder="City" class="form-control">
            </div>
            <div class="col-md-2">
              <label for="">City Latitude : </label>
              <input type="text" [(ngModel)]="cityLatitude" class="form-control" placeholder="City latitude" [disabled]="true">
            </div>
            <div class="col-md-2">
              <label for="">City Longtitude : </label>
              <input type="text" [(ngModel)]="cityLongtitude" class="form-control" placeholder="City longtitude"  [disabled]="true">
            </div>
            
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-2"></div>
              <div class="col-md-4">
                <label for="">Home Stop : </label>
                <input type="text" (onAddressChange)="getHomeStopData($event)"  ngx-google-places-autocomplete   placeholder="Home Stop" class="form-control">
              </div>
              <div class="col-md-2">
                <label for="">Home Stop Lat: </label>
                <input type="text" [(ngModel)]="homeStopLat" class="form-control" placeholder="Home Stop latitude" [disabled]="true">
              </div>
              <div class="col-md-2">
                <label for="">Home Stop Long: </label>
                <input type="text" [(ngModel)]="homeStopLng" class="form-control" placeholder="Home Stop longtitude"  [disabled]="true">
              </div>
              
              <div class="col-md-2"></div>
            </div>

          <div class="row">
            <div class="col-md-2"></div>
              <div class="col-md-4">
                <label for="">Vehicle Type : </label>
                <select class="form-control" [(ngModel)]="vehicleType">
                  <option value="">Select Vehicle Type</option>
                  <option value="{{data.type}}" *ngFor="let data of allVehiclesList">{{data.type}}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label for="">Source : </label>
                <input type="text"   class="form-control" placeholder="Source" [(ngModel)]="source">
              </div>
              <div class="col-md-2"></div>
            </div>
            <div class="row">
              <div class="col-md-2"></div>
                <div class="col-md-4">
                  <label for="">Vehical Number</label>
                  <input type="text"  class="form-control" placeholder="MH-00 AB0000" [(ngModel)]="vehicleNumber">
                </div>
                <div class="col-md-1">
                  <label for="">Controlled by admin</label>
                  <input type="checkbox" ([ngModel])="isControlledByAdmin" (change)="isControlledByAdmin = !isControlledByAdmin">
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row"  *ngIf="!isControlledByAdmin">
                <div class="col-md-2"></div>
                  <hr class="col-md-8 mt-2">
                </div>
              <div *ngIf="!isControlledByAdmin">
                <div class="row">
                  <div class="col-md-2"></div>
                    <h6 class="col-md-4">Bank Details</h6>
                  </div>
  
                  <div class="row">
                  
                    <div class="col-md-2"></div>
                      <div class="col-md-4">
                        
                        <label for="">Enter Name As Per Bank Record </label>
                        <input type="text"  class="form-control" placeholder="Enter Name As Per Bank Record" [(ngModel)]="nameAsPerBank">
                      </div>
                      <div class="col-md-4">
                        <label for="">Account No: </label>
                        <input type="text"   class="form-control" placeholder="Account Number" [(ngModel)]="bankAccountNumber">
                      </div>
                      <div class="col-md-2"></div>
                    </div>
                    
                    <div class="row">
                  
                      <div class="col-md-2"></div>
                        <div class="col-md-4">
                          
                          <label for="">IFSC Code </label>
                          <input type="text"  class="form-control" placeholder="IFSC Code" [(ngModel)]="ifscCode">
                        </div>
                        <div class="col-md-4">
                          <label for="">Bank Name</label>
                          <input type="text"   class="form-control" placeholder="Branch Name" [(ngModel)]="bankName">
                        </div>
                        <div class="col-md-2"></div>
                      </div>
  
                        <div class="row">
                          <div class="col-md-2"></div>
                          <div class="col-md-4">
                              <label for="">UPI ID</label>
                              <div class="input-group">
                                <input type="text" class="form-control" placeholder="UPI Id" [(ngModel)]="upiID">                               
                              </div>
                          </div>
                          <div class="col-md-4">
                            <label for="">UPI Mobile Number</label>
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="UPI Mobile Number" [(ngModel)]="upiMobileNumber">                               
                            </div>
                        </div>
                          <div class="col-md-2"></div>
                      </div>
                      
                      <div class="row">
                        <div class="col-md-2"></div>
                        <div class="col-md-4">
                          <label for="">Digital Wallet</label>
                          <div class="input-group">
                            <select class="form-control" [(ngModel)]="paymentApp">
                              <option value="">Select Digital Wallet</option>
                              <option value="PhonePay">PhonePay</option>
                              <option value="Gpay">Gpay</option>
                              <option value="Paytm">Paytm</option>
                            </select>                              
                          </div>
                      </div>
                      <div class="col-md-2"></div>
                      </div>
                      
              </div>
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <button  (click)="adddriver()"  [disabled]=" !fName || !lName|| !mobileNumber || !cityLatitude || !cityLongtitude || !homeStopLat || !homeStopLng || !vehicleType || !vehicleNumber"    class="btn btn-primary btn-lg btn-block">Add Driver</button>
                </div>
              </div>
  


              
              

              

              
                
              <!-- <div class="row">
                <div class="col-md-2"></div>
                  <hr class="col-md-8 mt-2">
                </div> -->
            <!-- <div>
              <div class="row">
                <div class="col-md-2"></div>
                  <h6 class="col-md-4">Bank Details</h6>
                </div>

                <div class="row">
                
                  <div class="col-md-2"></div>
                    <div class="col-md-4">
                      
                      <label for="">Enter Name As Per Bank Record </label>
                      <input type="text"  class="form-control" placeholder="Enter Name As Per Bank Record" [(ngModel)]="nameAsBank">
                    </div>
                    <div class="col-md-4">
                      <label for="">Account No: </label>
                      <input type="text"   class="form-control" placeholder="Account Number" [(ngModel)]="accountNo">
                    </div>
                    <div class="col-md-2"></div>
                  </div>
                  
                  <div class="row">
                
                    <div class="col-md-2"></div>
                      <div class="col-md-4">
                        
                        <label for="">IFSC Code </label>
                        <input type="text"  class="form-control" placeholder="IFSC Code" [(ngModel)]="ifscCode">
                      </div>
                      <div class="col-md-4">
                        <label for="">Branch Name</label>
                        <input type="text"   class="form-control" placeholder="Branch Name" [(ngModel)]="branchName">
                      </div>
                      <div class="col-md-2"></div>
                    </div>

                      <div class="row">
                        <div class="col-md-2"></div>
                        <div class="col-md-4">
                            <label for="">UPI ID</label>
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="UPI Id" [(ngModel)]="upiId">
                                <div class="input-group-prepend">
                                    <button class="btn btn-success" type="button" (click)="verify()">Verify</button>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    
            </div>
   -->
  
    
  </div>
  </div>
  </div>
  
    </div>
    
  </div>